const ChatMapTab = () => {
  return <div className="map"></div>;
};

export default ChatMapTab;
